import { FC } from 'react'

const HMLogo: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  fill,
  height,
  width,
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width || '40'}
      height={height || '40'}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g fill={fill || '#1D1D1F'} clipPath='url(#hm-logo-clip)'>
        <path d='m24.784 9.906-3.347 5.407 1.994.176-8.388 7.327 3.203-5.408h-1.457l1.457-7.502h-7.129v20.188h6.46v-3.89l4.845-4.232v8.122h6.46V9.906z' />
        <path d='M20 3.15c9.291 0 16.85 7.559 16.85 16.85S29.291 36.85 20 36.85 3.15 29.291 3.15 20 10.709 3.15 20 3.15M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0' />
      </g>
      <defs>
        <clipPath id='hm-logo-clip'>
          <path fill='#fff' d='M0 0h40v40H0z' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HMLogo
